import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Правила публикации пользовательского контента.
 *
 * Страница обязана описывать то, что реально делает сервер (App Store
 * Guideline 1.2 — ревьюер сверяет заявленное с поведением приложения):
 * премодерация текста по стоп-листу, жалоба с разбором за 24 часа,
 * блокировка автора, постмодерация фотографий.
 *
 * Меняете правила модерации на бэке — правьте и этот текст.
 */
export const UgcRulesContent: React.FC = () => (
  <>
    <p>
      В QPrice пользователи оставляют отзывы о заведениях: оценку, текст и до трёх фотографий.
      Отзывы видны всем — и другим гостям, и самому заведению. Эти правила описывают, что
      публиковать можно, что нельзя и что происходит с нарушениями.
    </p>

    <h2>1. Что можно публиковать</h2>
    <p>
      1.1. Личный опыт посещения заведения: качество еды и напитков, обслуживание, чистота,
      атмосфера, соответствие акции заявленным условиям.
    </p>
    <p>
      1.2. Фотографии, сделанные вами в заведении: блюда, интерьер, меню, чек.
    </p>
    <p>
      1.3. Критика — в том числе резкая, если она по делу и без оскорблений. Низкая оценка
      сама по себе поводом для удаления отзыва не является.
    </p>

    <h2>2. Что публиковать нельзя</h2>
    <p>2.1. Нецензурную лексику, оскорбления, унижение по любому признаку, угрозы.</p>
    <p>
      2.2. Разжигание вражды и ненависти, призывы к насилию, дискриминацию по национальности,
      религии, полу, возрасту, состоянию здоровья или иным признакам.
    </p>
    <p>
      2.3. Заведомо ложные сведения о заведении, накрутку оценок, отзывы о заведениях,
      в которых вы не были, и отзывы конкурентов.
    </p>
    <p>
      2.4. Рекламу и спам: телефоны, ссылки, ники в мессенджерах и соцсетях, предложения
      товаров и услуг.
    </p>
    <p>
      2.5. Персональные данные третьих лиц — имена сотрудников вместе с обвинениями, номера
      телефонов, адреса, фотографии людей без их согласия.
    </p>
    <p>
      2.6. Материалы порнографического характера, сцены насилия, изображения, нарушающие
      закон Республики Казахстан.
    </p>
    <p>
      2.7. Чужой контент, права на который вам не принадлежат: фотографии из интернета,
      тексты чужих отзывов.
    </p>

    <h2>3. Автоматическая проверка при публикации</h2>
    <p>
      3.1. Текст отзыва проверяется автоматически перед публикацией. Отзыв с нецензурной
      лексикой, оскорблениями, телефонами, ссылками или никами в мессенджерах не публикуется —
      приложение сразу сообщает об этом и предлагает исправить текст.
    </p>
    <p>
      3.2. Фотографии проверяет модератор — после публикации, по жалобам пользователей и
      выборочно.
    </p>

    <h2>4. Жалоба на отзыв</h2>
    <p>
      4.1. Рядом с каждым чужим отзывом в приложении есть меню «⋯» с пунктом «Пожаловаться».
      Укажите причину — спам, оскорбления, ложная информация или другое — и при желании
      добавьте комментарий.
    </p>
    <p>
      4.2. <strong style={{ color: 'var(--qp-ink)' }}>Каждая жалоба рассматривается в течение 24 часов.</strong>{' '}
      Отзыв, нарушающий эти правила, снимается с публикации: он исчезает из приложения и
      перестаёт влиять на рейтинг заведения.
    </p>
    <p>
      4.3. Если жалоба не подтвердилась, отзыв остаётся на месте. Повторная жалоба того же
      пользователя на тот же отзыв не принимается.
    </p>
    <p>
      4.4. Пожаловаться можно и напрямую — через{' '}
      <Link to="/support">страницу поддержки</Link>. Так же поступают заведения, если считают
      отзыв недобросовестным.
    </p>

    <h2>5. Блокировка автора</h2>
    <p>
      5.1. В том же меню «⋯» есть пункт «Заблокировать автора». Отзывы заблокированного
      пользователя перестают показываться вам сразу и не появляются снова.
    </p>
    <p>
      5.2. Блокировка односторонняя: заблокированный пользователь о ней не узнаёт и продолжает
      пользоваться приложением.
    </p>
    <p>
      5.3. Список заблокированных доступен в меню приложения — оттуда блокировку можно снять
      в один тап.
    </p>

    <h2>6. Последствия нарушений</h2>
    <p>
      6.1. Отзыв, нарушающий правила, снимается с публикации без предупреждения.
    </p>
    <p>
      6.2. При систематических нарушениях — оскорблениях, спаме, накрутке — аккаунт может быть
      ограничен в возможности оставлять отзывы или заблокирован полностью.
    </p>
    <p>
      6.3. Свой отзыв автор может удалить сам в любой момент, а вместе с аккаунтом удаляются
      все оставленные им отзывы и фотографии.
    </p>

    <h2>7. Контакты</h2>
    <p>
      Вопросы по модерации, спорные решения и жалобы на действия модератора —{' '}
      <a href="mailto:partner@qprice.kz">partner@qprice.kz</a> или{' '}
      <a href="https://wa.me/77772468483" target="_blank" rel="noopener noreferrer">
        WhatsApp +7 777 246 84 83
      </a>
      . Отвечаем в течение рабочего дня, жалобы на отзывы разбираем в течение 24 часов.
    </p>
  </>
);
